import { Box, Modal } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../../../api/hooks/useColors";
import { Toast } from "../../../../../../../../components/Toast";
import AcceptSection from "./AcceptSection";
import ButtonsSection from "./ButtonsSection";
import EntitiesStep from "./entitiesStep/EntitiesStep";
import SuccessModal from "./SuccessModal";
import SummaryStep from "./SummaryStep";
import WizardHeader from "./WizardHeader";

export default function AutoRemediationWizard({
  showWizard,
  setShowWizard,
  remediation,
  fullControl,
}) {
  const colors = useColors();
  const [step, setStep] = useState(1);
  const [accepted, setAccepted] = useState(false);
  const { autoRemediate } = useAPI();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedEntityIDsMapping, setSelectedEntityIDsMapping] = useState({});
  const anyEntitySelected = Object.keys(selectedEntityIDsMapping).length > 0;

  const componentAndArgsByStepNumber = {
    1: {
      component: EntitiesStep,
      args: {
        fullControl,
        selectedEntityIDsMapping,
        setSelectedEntityIDsMapping,
      },
    },
    2: { component: SummaryStep, args: { remediation } },
  };
  const numberOfSteps = Object.keys(componentAndArgsByStepNumber).length;

  const autoRemediateMutation = useMutation({
    mutationFn: () =>
      autoRemediate(fullControl.control_id, selectedEntityIDsMapping),
    onSuccess: () => {
      Toast.success("Auto-remediation applied successfully");
      setShowSuccessModal(true);
    },
    onError: () => {
      Toast.error("Failed applying auto-remediation");
      setShowWizard(false);
    },
  });

  const StepComponent = componentAndArgsByStepNumber[step].component;
  const stepComponentArgs = componentAndArgsByStepNumber[step].args;

  const handleClose = () => {
    if (!autoRemediateMutation.isPending) {
      setShowSuccessModal(false);
      setShowWizard(false);
    }
  };

  return (
    <>
      <Modal open={showWizard} onClose={handleClose}>
        <Box
          width="965px"
          padding="24px"
          position="absolute"
          borderRadius="10px"
          top="50%"
          left="50%"
          sx={{
            transform: "translate(-50%, -50%)",
            backgroundColor: colors.modal_bg,
            outline: "none",
          }}
        >
          <Box display="flex" flexDirection="column" gap={3}>
            <WizardHeader
              step_number={step}
              title="Apply Remediation to Selected Entities"
              control={fullControl}
              remediation={remediation}
              handleClose={handleClose}
              loadingConfirmation={autoRemediateMutation.isPending}
            />
            <StepComponent {...stepComponentArgs} />
            {step === numberOfSteps && (
              <AcceptSection
                accepted={accepted}
                setAccepted={setAccepted}
                loadingConfirmation={autoRemediateMutation.isPending}
              />
            )}
            <ButtonsSection
              step={step}
              setStep={setStep}
              numberOfSteps={numberOfSteps}
              handleClose={handleClose}
              accepted={accepted}
              handleConfirmation={() => autoRemediateMutation.mutate()}
              loadingConfirmation={autoRemediateMutation.isPending}
              anyEntitySelected={anyEntitySelected}
            />
          </Box>
        </Box>
      </Modal>
      <SuccessModal
        controlID={fullControl.control_id}
        showSuccessModal={showSuccessModal}
        handleClose={handleClose}
      />
    </>
  );
}
